export type TFormState = {
  canSubmit: boolean;
  formSubmission: TSubmit;
};

export const initialState: TFormState = {
  canSubmit: false,
  formSubmission: undefined,
};

export type TSubmit = 'failed' | 'success' | 'submitting' | undefined;

export type TFormActions =
  | {
      type: 'canSubmit';
      value: boolean;
    }
  | {
      type: 'formSubmission';
      value: TSubmit;
    };

export function formSubmissionReducer(
  state: TFormState,
  action: TFormActions,
): TFormState {
  switch (action.type) {
    case 'canSubmit':
      return { ...state, canSubmit: action.value };

    case 'formSubmission':
      return { ...state, formSubmission: action.value };

    default:
      throw new Error();
  }
}
